import { useState, useEffect } from "react";

/**
 * 미디어 쿼리 일치 여부를 구독한다.
 *
 * 레이아웃 차이는 Tailwind 의 md: / lg: 로 처리하는 것이 원칙이고,
 * 이 훅은 "브레이크포인트마다 렌더할 컴포넌트 자체가 다른" 경우에만 쓴다.
 * (예: 데스크톱은 애니메이션 마퀴, 모바일은 정적 그리드)
 *
 * resize 마다 상태가 바뀌던 기존 방식과 달리 경계를 넘을 때만 갱신된다.
 */
export const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(() =>
        typeof window === "undefined" ? false : window.matchMedia(query).matches
    );

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mql = window.matchMedia(query);
        const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);

        setMatches(mql.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return matches;
};

/** Tailwind 의 md 브레이크포인트(768px)와 같은 기준 */
export const useIsDesktop = () => useMediaQuery("(min-width: 768px)");
